import React from 'react';
import Preloader from './PageComponents/Preloader';
import Header from './PageComponents/Header';
import Footer from './PageComponents/Footer';
import { 
  Home, 
  Visibility, 
  Accessibility, 
  VerifiedUser, 
  ConnectWithoutContact,
  People,
  Chat,
  AssignmentInd,
  Notifications
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function Index() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div className="votevocal-app" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Header />
      
      {/* Hero Section */}
      <section className="hero-section" style={{
        background: 'linear-gradient(135deg, #1a237e 0%, #283593 50%, #3949ab 100%)',
        color: 'white',
        padding: isMobile ? '60px 20px' : '100px 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-1 order-2">
              <div className="hero-content" style={{
                animation: 'fadeInUp 0.8s ease-out'
              }}>
                <h1 style={{
                  fontSize: isMobile ? '2.2rem' : '3rem',
                  fontWeight: 700,
                  lineHeight: 1.2,
                  marginBottom: '20px'
                }}>
                  Connect with Your <span style={{ color: '#4fc3f7' }}>Elected Representatives</span>
                </h1>
                <p style={{
                  fontSize: '1.1rem',
                  marginBottom: '30px',
                  opacity: 0.9
                }}>
                  VoteVocal bridges the gap between citizens & their government. Download now to engage with your representatives and stay informed about local issues.
                </p>
                <div className="download-buttons" style={{
                  display: 'flex',
                  gap: '15px',
                  flexWrap: 'wrap'
                }}>
                  <a href="https://apps.apple.com/us/app/vote-vocal/id6499540241" 
                    className="download-btn"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      backgroundColor: 'white',
                      color: '#1a237e',
                      padding: '12px 20px',
                      borderRadius: '8px',
                      fontWeight: 600,
                      textDecoration: 'none',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                  >
                    <i className="fab fa-apple" style={{ fontSize: '1.5rem', marginRight: '10px' }}></i>
                    <div>
                      <div style={{ fontSize: '0.7rem' }}>Download on the</div>
                      <div style={{ fontSize: '1.1rem' }}>App Store</div>
                    </div>
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.votevocal.info.vv" 
                    className="download-btn"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      backgroundColor: 'white',
                      color: '#1a237e',
                      padding: '12px 20px',
                      borderRadius: '8px',
                      fontWeight: 600,
                      textDecoration: 'none',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                  >
                    <i className="fab fa-google-play" style={{ fontSize: '1.5rem', marginRight: '10px' }}></i>
                    <div>
                      <div style={{ fontSize: '0.7rem' }}>Get it on</div>
                      <div style={{ fontSize: '1.1rem' }}>Google Play</div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 order-lg-2 order-1 mb-4 mb-lg-0">
              <div className="hero-media" style={{
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                transform: 'perspective(1000px) rotateY(-5deg)',
                transition: 'transform 0.5s ease',
                maxWidth: '100%'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'perspective(1000px) rotateY(-5deg)'}
              >
                <video
                  autoPlay
                  loop
                  muted
                  controls
                  playsInline
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                >
                  <source src="/assets/images/promo.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="vision-mission" style={{
        padding: '80px 0',
        backgroundColor: '#f8f9fa'
      }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row g-4">
                <div className="col-md-6">
                  <div className="vision-card" style={{
                    backgroundColor: 'white',
                    borderRadius: '16px',
                    padding: '40px',
                    height: '100%',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                    borderLeft: '5px solid #4fc3f7',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                  >
                    <h2 style={{
                      color: '#1a237e',
                      marginBottom: '20px',
                      fontSize: '2rem',
                      fontWeight: 700
                    }}>
                      Our Vision
                    </h2>
                    <p style={{
                      fontSize: '1.1rem',
                      lineHeight: 1.8,
                      color: '#555'
                    }}>
                      Amplify every voice and inspire active participation from communities and elected officials to create a more engaged and responsive democracy.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mission-card" style={{
                    backgroundColor: 'white',
                    borderRadius: '16px',
                    padding: '40px',
                    height: '100%',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                    borderLeft: '5px solid #66bb6a',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                  >
                    <h2 style={{
                      color: '#1a237e',
                      marginBottom: '20px',
                      fontSize: '2rem',
                      fontWeight: 700
                    }}>
                      Our Mission
                    </h2>
                    <p style={{
                      fontSize: '1.1rem',
                      lineHeight: 1.8,
                      color: '#555'
                    }}>
                      Deliver impartial information to promote civic engagement, strengthen communities, and support elected officials in serving their constituents more effectively.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section" style={{
        padding: '80px 0',
        backgroundColor: 'white'
      }}>
        <div className="container">
          <div className="section-header text-center mb-5">
            <h2 style={{
              color: '#1a237e',
              fontSize: '2.5rem',
              fontWeight: 700,
              marginBottom: '15px'
            }}>
              Our <span style={{ color: '#4fc3f7' }}>Core Values</span>
            </h2>
            <p style={{
              color: '#666',
              fontSize: '1.1rem',
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              These principles guide everything we do at VoteVocal
            </p>
          </div>
          
          <div className="row g-4 justify-content-center">
            {[
              {
                icon: <Home style={{ fontSize: '3rem' }} />,
                title: 'Empowerment',
                description: 'Drive change through the participation of elected officials and citizens alike.',
                color: '#4fc3f7'
              },
              {
                icon: <Visibility style={{ fontSize: '3rem' }} />,
                title: 'Transparency',
                description: 'Ensure clarity and neutrality in all government communications and processes.',
                color: '#66bb6a'
              },
              {
                icon: <Accessibility style={{ fontSize: '3rem' }} />,
                title: 'Accessibility',
                description: 'Make government resources understandable and available for all community members.',
                color: '#ffa726'
              },
              // {
              //   icon: <VerifiedUser style={{ fontSize: '3rem' }} />,
              //   title: 'Integrity',
              //   description: 'Uphold honesty and impartiality in all initiatives involving elected officials.',
              //   color: '#ef5350'
              // },
              {
                icon: <ConnectWithoutContact style={{ fontSize: '3rem' }} />,
                title: 'Connection',
                description: 'Build relationships between officials and communities to enhance democratic participation.',
                color: '#ab47bc'
              }
            ].map((value, index) => (
              <div className="col-md-4 col-lg-3" key={index}>
                <div className="value-card" style={{
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  padding: '30px',
                  height: '100%',
                  boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
                  borderTop: `4px solid ${value.color}`,
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  textAlign: 'center'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <div className="value-icon mb-4" style={{ color: value.color }}>
                    {value.icon}
                  </div>
                  <h4 style={{
                    color: '#1a237e',
                    marginBottom: '15px',
                    fontWeight: 600
                  }}>
                    {value.title}
                  </h4>
                  <p style={{ color: '#666', lineHeight: 1.6 }}>
                    {value.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section" style={{
        padding: '80px 0',
        backgroundColor: '#f8f9fa'
      }}>
        <div className="container">
          <div className="section-header text-center mb-5">
            <h2 style={{
              color: '#1a237e',
              fontSize: '2.5rem',
              fontWeight: 700,
              marginBottom: '15px'
            }}>
              Powerful <span style={{ color: '#4fc3f7' }}>Features</span>
            </h2>
            <p style={{
              color: '#666',
              fontSize: '1.1rem',
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              Discover how VoteVocal enhances your civic engagement experience
            </p>
          </div>
          
          <div className="row g-4">
            {[
              {
                icon: <People style={{ fontSize: '3rem', color: '#4fc3f7' }} />,
                title: 'Find Your Representatives',
                description: 'Locate your local representatives at town, county, state, and federal levels with our intuitive search tools.'
              },
              {
                icon: <Chat style={{ fontSize: '3rem', color: '#66bb6a' }} />,
                title: 'Raise Issues',
                description: 'Directly communicate your concerns and raise issues to your elected representatives for resolution.'
              },
              {
                icon: <AssignmentInd style={{ fontSize: '3rem', color: '#ffa726' }} />,
                title: 'Representative Profiles',
                description: 'Access comprehensive profiles of your representatives to learn about their work, initiatives, and voting records.'
              },
              {
                icon: <Notifications style={{ fontSize: '3rem', color: '#ab47bc' }} />,
                title: 'Stay Informed',
                description: 'Receive personalized updates and news from your followed representatives about their agendas and activities.'
              }
            ].map((feature, index) => (
              <div className="col-md-6 col-lg-3" key={index}>
                <div className="feature-card" style={{
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  padding: '30px',
                  height: '100%',
                  boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <div className="feature-icon mb-4">
                    {feature.icon}
                  </div>
                  <h4 style={{
                    color: '#1a237e',
                    marginBottom: '15px',
                    fontWeight: 600
                  }}>
                    {feature.title}
                  </h4>
                  <p style={{ color: '#666', lineHeight: 1.6 }}>
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section" style={{
        padding: '80px 0',
        background: 'linear-gradient(135deg, #1a237e 0%, #283593 100%)',
        color: 'white',
        textAlign: 'center'
      }}>
        <div className="container">
          <h2 style={{
            fontSize: isMobile ? '2rem' : '2.5rem',
            fontWeight: 700,
            marginBottom: '20px'
          }}>
            Ready to Make Your Voice Heard?
          </h2>
          <p style={{
            fontSize: '1.2rem',
            maxWidth: '700px',
            margin: '0 auto 30px',
            opacity: 0.9
          }}>
            Download VoteVocal today and start engaging with your representatives directly.
          </p>
          <div className="download-buttons" style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            flexWrap: 'wrap'
          }}>
            <a href="https://apps.apple.com/us/app/vote-vocal/id6499540241" 
              className="download-btn"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: 'white',
                color: '#1a237e',
                padding: '12px 25px',
                borderRadius: '8px',
                fontWeight: 600,
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
              }}
            >
              <i className="fab fa-apple" style={{ fontSize: '1.5rem', marginRight: '10px' }}></i>
              <div>
                <div style={{ fontSize: '0.7rem' }}>Download on the</div>
                <div style={{ fontSize: '1.1rem' }}>App Store</div>
              </div>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.votevocal.info.vv" 
              className="download-btn"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: 'white',
                color: '#1a237e',
                padding: '12px 25px',
                borderRadius: '8px',
                fontWeight: 600,
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
              }}
            >
              <i className="fab fa-google-play" style={{ fontSize: '1.5rem', marginRight: '10px' }}></i>
              <div>
                <div style={{ fontSize: '0.7rem' }}>Get it on</div>
                <div style={{ fontSize: '1.1rem' }}>Google Play</div>
              </div>
            </a>
          </div>
        </div>
      </section>

      <Footer />
      
      <style jsx global>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        body {
          font-family: 'Inter', sans-serif;
          margin: 0;
          padding: 0;
          color: #333;
        }
        
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }
        
        .row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -15px;
        }
        
        .col-lg-6, .col-md-6, .col-lg-3, .col-md-4, .col-md-12 {
          padding: 0 15px;
          box-sizing: border-box;
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @media (max-width: 768px) {
          .hero-section {
            text-align: center;
          }
          
          .download-buttons {
            justify-content: center;
          }
        }
      `}</style>
    </div>
  );
}

export default Index;